"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPubSub = void 0;
const createPubSub = () => {
    const subscribers = new Map();
    const subscribe = (topic, handler) => {
        if (!subscribers.has(topic)) {
            subscribers.set(topic, new Set());
        }
        const handlerSet = subscribers.get(topic);
        handlerSet.add(handler);
        return () => {
            handlerSet.delete(handler);
        };
    };
    const publish = (topic, ...args) => {
        const handlerSet = subscribers.get(topic);
        if (handlerSet) {
            handlerSet.forEach((handler) => handler(...args));
        }
    };
    return { publish, subscribe };
};
exports.createPubSub = createPubSub;
//# sourceMappingURL=pubSub.js.map